// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3PvPc","navbar":"Layout_navbar__15dt9","wrapper":"Layout_wrapper__267cj"};